<div
  class="insurance-data-card"
  [ngClass]="{ 'is-dashed': isDashed, 'is-with-hover': isShowAddIcon, 'is-full-height': isFullHeight, 'is-errored': isErrored }"
>
  <div class="insurance-data-card-header">
    <div class="insurance-data-card-header-info">
      <div class="w-100 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <h3 class="mr-1">
            {{ cardTitle | translate }}
            <span class="insurance-data-card-header-info-required" *ngIf="isErrored">{{ "LABELS.REQUIRED" | translate }}</span>
            <ng-content select="[header-label]"></ng-content>
          </h3>

          <app-hint-tooltip-icon [hint]="cardHint" [title]="cardHintTitle" *ngIf="!!cardHint"></app-hint-tooltip-icon>
        </div>

        <div class="d-flex justify-content-between">
          <button type="button" class="btn btn-link d-print-none" *ngIf="isCanEdit" (click)="edit.emit()">
            <img src="assets/icons/icon_edit_dark_gray.svg" />

            <span class="ml-1">{{ "BUTTON.EDIT" | translate }}</span>
          </button>

          <ng-content select="[header-actions-button]"></ng-content>
        </div>

        <ng-content select="[header]"></ng-content>
      </div>
    </div>
  </div>

  <div *ngIf="isShowAnimation" class="insurance-data-card-animation">
    <img class="insurance-data-card-animation__wave first-wave" src="assets/animations/marine-insurance/Wave.svg" alt="wave" />
    <img class="insurance-data-card-animation__wave second-wave" src="assets/animations/marine-insurance/Wave.svg" alt="wave" />

    <img class="insurance-data-card-animation__ship" src="assets/animations/marine-insurance/Ship with 2 containers.svg" alt="ship" />

    <img class="insurance-data-card-animation__container" src="assets/animations/marine-insurance/Container.svg" alt="container" />
  </div>

  <div class="insurance-data-card-body">
    <ng-content select="[body]"></ng-content>

    <div class="insurance-data-card-body-add-hover" *ngIf="isShowAddIcon" (click)="edit.emit()">
      <div class="insurance-data-card-body-add-hover-icon">
        <svg width="40" height="40" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="13.5" cy="13.5" r="13.5" fill="#03BCBE" />
          <path d="M6 12H21V15H6V12Z" fill="white" />
          <path d="M12 21V6H15V21H12Z" fill="white" />
        </svg>
      </div>
      <span>{{ "BUTTON.CLICK_TO_ADD" | translate }}</span>
    </div>
  </div>

  <div class="insurance-data-card-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
